import { useState, useEffect } from "react";
import { X, Search, Send } from "lucide-react";
import { toast } from "sonner";
import crm, { apiErr } from "../crmApi";
import { inr, fileSrc } from "./WebsiteApp";
import { listingUrl } from "./WmMedia";

const buildMsg = (lead, p) => [
  `Hi ${lead.customer_name.replace(/^\[DEMO\]\s*/, "")},`,
  "",
  `Sharing details of *${p.name}*${p.developer ? ` by ${p.developer}` : ""}:`,
  `📍 ${p.locality}, ${p.city}`,
  `💰 Starting ${inr(p.price)}`,
  p.configurations?.length ? `🏠 ${p.configurations.join(", ")}` : p.bedrooms ? `🏠 ${p.bedrooms} BHK` : "",
  p.area_sqft ? `📐 ${p.area_sqft} sq.ft` : "",
  "",
  p.description || "",
  "",
  `Photos, videos & full details: ${listingUrl(p.slug)}`,
  p.brochure ? `Brochure: ${fileSrc(p.brochure)}` : "",
  "",
  "— Team PlotBySquare",
].filter((l, i, a) => l !== "" || a[i - 1] !== "").join("\n");

export default function ShareProperty({ lead, onClose, onDone }) {
  const [listings, setListings] = useState(null);
  const [q, setQ] = useState("");
  const [pick, setPick] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { crm.wm.media().then((d) => setListings(d.listings)).catch((e) => { toast.error(apiErr(e)); setListings([]); }); }, []);
  const choose = (p) => { setPick(p); setMsg(buildMsg(lead, p)); };
  const send = async () => {
    setBusy(true);
    const w = window.open("about:blank", "_blank");
    try {
      await crm.wm.share({ lead_id: lead.id, property_id: pick.id, message: msg });
      const url = `https://wa.me/${(lead.mobile_norm || "").length === 10 ? `91${lead.mobile_norm}` : lead.mobile_norm}?text=${encodeURIComponent(msg)}`;
      if (w) w.location.href = url; else window.location.href = url;
      toast.success("Shared — a copy of the message is saved in the activity timeline");
      onDone();
    } catch (e) { w?.close(); toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const list = (listings || []).filter((p) => `${p.name} ${p.city} ${p.locality} ${p.developer}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"><div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] flex flex-col" data-testid="share-modal">
        <div className="flex items-center justify-between px-5 py-3 border-b border-pbs-line"><h3 className="font-bold text-pbs-dark">Share Property with {lead.customer_name}</h3><button onClick={onClose}><X size={18} /></button></div>
        {!pick ? (
          <div className="p-4 overflow-y-auto">
            <div className="flex items-center gap-2 border border-pbs-line rounded-lg px-3 mb-3"><Search size={15} className="text-pbs-grey" /><input autoFocus data-testid="share-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search approved listings" className="flex-1 py-2 outline-none text-sm" /></div>
            {!listings ? <p className="text-sm text-pbs-grey">Loading…</p> : list.map((p) => (
              <button key={p.id} onClick={() => choose(p)} data-testid={`share-pick-${p.slug}`} className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-pbs-bg text-left">
                {p.image && <img src={fileSrc(p.image)} alt="" className="w-16 h-12 rounded-md object-cover" />}
                <div className="min-w-0"><p className="font-semibold text-sm text-pbs-dark truncate">{p.name}</p><p className="text-xs text-pbs-grey">{p.locality}, {p.city} · {inr(p.price)}</p></div>
              </button>
            ))}
          </div>
        ) : (
          <div className="p-4 overflow-y-auto space-y-3">
            <div className="flex items-center gap-3">{pick.image && <img src={fileSrc(pick.image)} alt="" className="w-20 h-14 rounded-md object-cover" />}<div><p className="font-bold text-sm">{pick.name}</p><p className="text-xs text-pbs-grey">Latest approved version v{pick.version}</p></div><button onClick={() => setPick(null)} className="ml-auto text-xs font-bold text-pbs-purple">Change</button></div>
            <textarea rows={12} className="crm-in font-mono text-xs" data-testid="share-message" value={msg} onChange={(e) => setMsg(e.target.value)} />
            <button disabled={busy || !msg.trim()} onClick={send} data-testid="share-send" className="w-full py-2.5 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg inline-flex items-center justify-center gap-2 disabled:opacity-50"><Send size={15} /> Send via WhatsApp & Log</button>
          </div>
        )}
      </div>
    </div>
  );
}
